import { DEFAULT_DATE_FORMAT } from 'module/types/common';
import moment from 'moment';
import { KeyCreatorFunction } from './types';

const durations = {
  Today: 'today',
  Tomorrow: 'tomorrow',
  NextSevenDays: 'next_seven_days',
  LastSevenDays: 'last_seven_days',
  DueSoon: 'due_soon',
  OlderProjects: 'older_projects',
  None: 'no_due_date',
};

export const defaultDueDateOrder = [
  durations.Today,
  durations.Tomorrow,
  durations.NextSevenDays,
  durations.LastSevenDays,
  durations.DueSoon,
  durations.OlderProjects,
  durations.None,
];

function getLabel(diff) {
  switch (true) {
    case diff === 0:
      return durations.Today;
    case diff === 1:
      return durations.Tomorrow;
    case diff > 1 && diff <= 7:
      return durations.NextSevenDays;
    case diff > 7:
      return durations.DueSoon;
    case diff >= -7 && diff < 0:
      return durations.LastSevenDays;
    case diff < -7:
      return durations.OlderProjects;
    default:
      return durations.None;
  }
}
export const dueDateKeyCreator: KeyCreatorFunction = ({ value: date }) => {
  const diff = date
    ? moment(date).diff(moment().format(DEFAULT_DATE_FORMAT), 'days')
    : undefined;

  return getLabel(diff);
};
